module.exports = __webpack_public_path__ + "static/empty-state-value-props-linked-text-do-49fce4cacc273f18445aa80e9be4cab5.png";